export const AdministerApplication = 'AdministerApplication';

export const NoAccess = 'NoAccess';
export const Access = 'Access';
export const ManageUserReport = 'ManageUserReport';
export const ViewReporting = 'ViewReporting';

export const ReadAllComplianceReports = 'ReadAllComplianceReports';
export const MutateAllComplianceReports = 'MutateAllComplianceReports';

export const ViewReportApprovalFlow = 'ViewReportApprovalFlow';

export const ReadAllComplianceIncidents = 'ReadAllComplianceIncidents';
export const MutateAllComplianceIncidents = 'MutateAllComplianceIncidents';
export const MutateDossiers = 'MutateDossiers';

export const ReadComplianceProcessingActivities = 'ReadComplianceProcessingActivities';
export const MutateComplianceProcessingActivities = 'MutateComplianceProcessingActivities';
export const IsCompliancyEmployee = 'IsCompliancyEmployee';
